var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAnimated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "yecomsoft-ic-animated",
    textRendering: "geometricPrecision",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6333F;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.8,205.1L360.2,54.3L132.8,220.4l127.8,92L408.8,205.1L408.8,205.1z M344.9,102.8l30.7,92l-115,81.8 l-76.7-56.2L344.9,102.8L344.9,102.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.6,345.6l-127.8-92L22.9,519.4h158.5L237.6,345.6L237.6,345.6z M63.8,491.3l61.3-191.7l76.7,56.2 l-43.4,135.5H63.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.8,562.9H22.9l86.9,265.8l127.8-92L178.8,562.9z M158.3,591l43.4,132.9L125,780.1L63.8,588.4h94.6v2.6 H158.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.1,769.9l-130.3,92L360.2,1028l48.6-148.2L263.1,769.9L263.1,769.9z M183.9,861.9l76.7-56.2l115,81.8 l-30.7,92L183.9,861.9L183.9,861.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,890l-48.6,148.2h281.1L633.7,890H449.7z M439.5,1010.1l30.7-92h140.6l30.7,92H439.5L439.5,1010.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M672,877.2l48.6,150.8l227.5-166.1l-127.8-92L672,877.2z M735.9,979.4l-30.7-92l115-81.8l76.7,56.2L735.9,979.4 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M843.3,736.6l127.8,92l86.9-265.8H899.5L843.3,736.6z M1017.1,591l-61.3,191.7l-76.7-56.2L922.5,591H1017.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M902.1,519.4H1058l-86.9-265.8l-127.8,92L902.1,519.4z M922.5,491.3l-43.4-132.9l76.7-56.2l61.3,191.7h-94.6 V491.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M817.7,312.4l130.3-92L720.6,54.3L672,202.5L817.7,312.4z M896.9,220.4l-76.7,56.2l-115-81.8l30.7-92 L896.9,220.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M631.2,192.3L679.7,44H398.6l48.6,148.2h184V192.3z M641.4,72.2l-30.7,92H470.1l-30.7-92 C439.4,72.2,641.4,72.2,641.4,72.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M632.4,191.3L681,43H399.9l48.6,148.2h183.9V191.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimated);
export default __webpack_public_path__ + "static/media/logo-animated.1d8dbff768e2186db189dcff440b3746.svg";
export { ForwardRef as ReactComponent };